/**
 * Shared dashed strip layout (Add Section button + section field drop target).
 * Pointer hover is only on the Add Section **button**; the field strip uses DnD `isOver` only.
 */
export const FORM_BUILDER_ADD_STRIP_BASE =
	"flex w-full items-center justify-center gap-2 rounded-lg border-2 border-dashed border-border-primary py-3 text-sm font-medium text-text-secondary transition-colors";

/** Reveal row toolbars when a control inside has keyboard focus (not only on hover). */
export const BUILDER_ROW_ACTIONS_VISIBILITY =
	"opacity-0 transition-opacity group-hover:opacity-100 group-focus-within:opacity-100";
